/* eslint-disable arrow-parens */
import moment from 'moment';
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import RegisterUser from '../../utils/awsCreateuser';
import reVerifyUser from '../../utils/awsVerifyUserAgain';
import SignIn from '../../utils/awsSigin';
import CheckEmailVerificationStatus from '../../utils/awsCheckEmailVerificationStatus';
import AwsConfirmPassword from '../../utils/awsConfirmPassword';
import AwsChangePassword from '../../utils/awsChangePassword';
import AwsChangePasswordByAdmin from '../../utils/awsChangePasswordByAdmin';
import awsDeleteMailCognito from '../../utils/awsDeleteMailCognito';
import { setTransactionHeader, getParentCompany, getCompanyListBasedOnParent } from '../../utils/userStoreHelper';
import {
  SET_UPDATE_COMPANY_ADMIN_GQL,
  SET_UPDATE_CREATING_SUB_COMPANY_STATUS_GQL,
  GET_ALL_USERS_GQL,
  GET_USER_ASSIGNED_COMPANIES_GQL,
  GET_COMAPANY_WISE_EXPENSE,
} from '@/graphql/user.gql';
import { isBulkTransactionsEnabled } from '@/utils/bulkTransactionsHelper';
import {
  GET_USERS_GQL,
  SIGNIN_USER_GQL,
  SIGNUP_USER_GQL,
  SIGNUP_USER_GQL2,
  GET_ME_GQL,
  SIGNUP_BUSINESS_GQL,
  FORGET_USER_GQL,
  UPDATE_USER_GQL,
  USER_UPDATE_GQL,
  GET_CURRENT_USER,
  UPDATE_USER_AVATAR_GQL,
  USER_GR_UPDATE_GQL,
  GET_USER_INFO_GQL,
  GET_USER_INFO_GQL_CARD,
  GET_USER_MIN_INFO_GQL,
  GET_USER_GROUP_BUDGET_INFO_GQL,
  GET_TEAM_USERS_GQL,
  GET_TEAM_USERS_GQL2,
  GET_STATES_GQL,
  GET_COUNTRIES_GQL,
  GET_INCORPORATION_TYPE_GQL,
  GET_AUTHORIZE_OFFICER_GQL,
  GET_GROUP_LIST_GQL,
  U_PERM_TEAM_CONNECT_GQL,
  GET_USERS_LIST_FOR_TEAM,
  GET_USER_PASS_GQL,
  UPDATE_USER_PASS_GQL,
  UPDATE_USER_INVITATION_DATE_GQL,
  UPDATE_USER_SETTING_GQL,
  CHECK_USER_INFO_GQL,
  GET_ADMIN_INFO_GQL,
  SET_ADD_SUPPORT_ADMIN_GQL,
  SET_UPDATE_SUPPORT_ADMIN_GQL,
  SET_REMOVE_PREVIOUS_PERMISSIONS_SELECTION_GQL,
  SET_TOGGLE_SUPPORT_ADMIN_STATUS_GQL,
  SEND_MESSAGE,
  SET_LOGOUT_TIME_GQL,
  GET_COMPANY_USER_LIST_GQL,
  GET_USER_INFO_FROM_EMAIL_GQL,
  SET_REMOVE_USER_FROM_COMPANY_GQL,
  SET_ACTIVATE_EMPLOYEE_FOR_COMPANY_GQL,
  CONNECT_NEW_COMPANY_TO_USER_GQL,
  SET_USER_SETTING_GQL,
  VERIFY_INVITATION_GQL,
  SIGNIN_USER_GQL_FOR_SUPER,
} from '@/graphql/queries.gql';


const initEmployee = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  userPhoto: '',
  teams: [],
  isAllCompanyAdmin: '',
};

export default {
  namespaced: true,

  state: {
    // = data
    users: [],
    // userSettingsForMe: [],
    listAllUser: [],
    getAllUserList: [],
    getSelUserList: [],
    me: null,
    signedInUser: null,
    signedInUserSuperAdmin: null,
    updatedUser: null,
    signedUpUser: null,
    updateUser: null,
    email: null,
    message: null,
    currentuser: null,
    avatar: null,
    changePasswordreply: null,
    addUserPerm: false,
    editUserPerm: false,
    getUserWithGrList: [],
    getUserWithGrListInactive: [],
    userInfo: Object.assign({}, initEmployee),
    userCardInfo: null,
    userMinInfo: Object.assign({}, initEmployee),
    getGroupUserBudget: [],
    getStateName: null,
    getBusinesstypes: null,
    getAuthoriseOfficer: null,
    getlatestrecord: null,
    userCompanyId: null,
    myParentCompany: null,
    userAccAccess: false,
    userCompanyStatus: null,
    paymentCycle: null,
    userCompanyName: null,
    LockDownStatus: false,
    getMyTeamList: [],
    myTeamList: [],
    myAllTeamList: [],
    addTeamPerm: false,
    adduserRolePerms: [],
    getMyTeamListUser: [],
    forgotPasswordMsg: null,
    getCountryName: null,
    getUserPass: null,
    userDetailsUpdate: [],
    updatedUserPass: null,
    setPasswordByAdminReply: null,
    getUserInfoToCheck: null,
    showCreateNewChildCompany: false,
    companyDetail: null,
    viewSentinelInsightPerm: null,
    allowGenerateStatementPerm: null,
    supportAdminId: null,
    companyUsersList: null,
    userInfoFromEmail: null,
    newCompanyToUserConnected: null,
    verifyInvitationRes: null,
    newUserEmail: null,
    employeeActivated: null,
    employeeRemoved: null,
    allUsersRes: [],
    userAssignedCompanies: [],
    companyWiseExpense: [],
  },

  mutations: {
    /* SET_USRSETTINGS_FOR_ME(state,payload) {
      state.userSettingsForMe = payload;
    }, */
    SET_REMOVE_USER_FROM_COMPANY(state, payload) {
      state.employeeRemoved = payload;
    },
    SET_ACTIVATE_EMPLOYEE_FOR_COMPANY(state, payload) {
      state.employeeActivated = payload;
    },
    SET_NEW_USER_EMAIL(state, payload) {
      state.newUserEmail = payload;
    },
    VERIFY_INVITATION(state, payload) {
      state.verifyInvitationRes = payload;
    },
    GET_USER_INFO_FROM_EMAIL(state, payload) {
      state.userInfoFromEmail = payload;
    },
    GET_ADMIN_USER(state, payload) {
      state.listAllUser = payload;
    },
    GET_USER_WITH_GR_LIST(state, payload) {
      state.getUserWithGrList = payload;
    },
    GET_USER_WITH_GR_LIST_INACTIVE(state, payload) {
      state.getUserWithGrListInactive = payload;
    },
    UPDATE_USER_WITH_GR_LIST(state, payload) {
      let userDetails = null;
      let userDetails2 = null;
      userDetails = state.getUserWithGrList.find((user) => user.id === payload.id);

      if (userDetails && payload.status === true) {
        // only Update case
        // console.log('-------------------UPDATE CASE-----------------');
        userDetails = state.getUserWithGrList.find((user) => user.id === payload.id);
        userDetails.firstName = payload.firstName;
        userDetails.lastName = payload.lastName;
        userDetails.email = payload.email;
        userDetails.userPhoto = payload.userPhoto;
        userDetails.teams = payload.teams;
      }

      if (userDetails && payload.status === false) {
        // console.log('-------------------Delete CASE-----------------');
        // only Remove Employee Case;
        userDetails = state.getUserWithGrList.find((user) => user.id === payload.id);
        state.getUserWithGrListInactive.push(userDetails);
        state.getUserWithGrList = state.getUserWithGrList.filter((ele) => ele.id !== payload.id);
      }


      if (!userDetails && payload.status === true) {
        // He is Actives back;
        // console.log('-------------------ACTIVE CASE-----------------');
        userDetails2 = state.getUserWithGrListInactive.find((user) => user.id === payload.id);
        state.getUserWithGrList.push(userDetails2);
        state.getUserWithGrListInactive = state.getUserWithGrListInactive.filter((ele) => ele.id !== payload.id);
      }

      // Sort byName
      state.getUserWithGrList.sort((a, b) => a.firstName.localeCompare(b.firstName));
      state.getUserWithGrListInactive.sort((a, b) => a.firstName.localeCompare(b.firstName));
    },
    SET_AVATAR(state, payload) {
      state.avatar = payload;
    },
    SET_AVATAR_LEFT_PANEL(state, payload) {
      if (state.getUserWithGrList.length > 0) {
        const userDetails = state.getUserWithGrList.find((user) => user.id === payload.id);
        userDetails.userPhoto = payload.userPhoto;
      }
    },
    SET_MESSAGE(state, payload) {
      state.message = payload;
    },
    SET_CURRENT_USERS(state, payload) {
      state.currentuser = payload;
    },
    SET_USERS(state, payload) {
      state.users = payload;
    },
    GET_USER_LIST(state, payload) {
      state.getAllUserList = payload;
    },
    GET_SEL_USER_LIST(state, payload) {
      state.getSelUserList = payload;
    },
    SET_SIGNED_IN_USER(state, payload) {
      state.signedInUser = payload;
    },
    SET_SIGNED_IN_USER_SUPER_ADMIN(state, payload) {
      state.signedInUserSuperAdmin = payload;
    },
    SET_SIGNED_UP_USER(state, payload) {
      state.signedUpUser = payload;
    },
    ADD_INACTIVE_USER_LEFT_PANEL(state, payload) {
      const userDetails = Object.assign({}, initEmployee);
      userDetails.firstName = payload.firstName;
      userDetails.id = payload.id;
      userDetails.lastName = payload.lastName;
      userDetails.email = payload.email;
      state.getUserWithGrListInactive.push(userDetails);
    },
    ADD_USER_LEFT_PANEL(state, payload) {
      const userDetails = Object.assign({}, initEmployee);
      userDetails.firstName = payload.firstName;
      userDetails.id = payload.id;
      userDetails.lastName = payload.lastName;
      userDetails.email = payload.email;
      state.getUserWithGrList.push(userDetails);
    },
    SET_USER_TEAM_LEFT_PANEL(state, payload) {
      if (state.getUserWithGrList.length > 0) {
        const userDetails = state.getUserWithGrList.find(user => user.id === payload.user.id);
        const checkTeam = userDetails.teams.find(teams => teams.id === payload.id);
        if (!checkTeam) { userDetails.teams.push(payload); }
      }
    },
    SET_UPDATED_USER(state, payload) {
      state.updatedUser = payload;
    },
    SET_GROUP_USER(state, payload) {
      state.removedGroup = payload;
    },
    SET_ME(state, payload) {
      state.me = payload;
    },
    SET_FORGET_EMAIL(state, payload) {
      state.email = payload;
    },
    CLEAR_ME(state) {
      state.me = null;
    },
    SET_CHANGEPASSWORD_NOTIFICATION(state, payload) {
      state.changePasswordreply = payload;
    },
    GET_USER_INFO(state, payload) {
      state.userInfo = payload;
    },
    SET_ADD_USER_PERM(state, payload) {
      state.addUserPerm = payload;
    },
    SET_EDIT_USER_PERM(state, payload) {
      state.editUserPerm = payload;
    },
    GET_USER_CARD_INFO(state, payload) {
      state.userCardInfo = payload;
    },
    GET_USER_MIN_INFO(state, payload) {
      state.userMinInfo = payload;
    },
    GET_USER_GROUP_BUDGET_INFO(state, payload) {
      state.getGroupUserBudget = payload;
    },
    GET_STATES(state, payload) {
      state.getStateName = payload;
    },
    GET_COUNTRIES(state, payload) {
      state.getCountryName = payload;
    },
    SET_BUSINESS_TYPE(state, payload) {
      state.getBusinesstypes = payload;
    },
    SET_AUTHORIZE_OFFICER(state, payload) {
      state.getAuthoriseOfficer = payload;
    },
    GET_LATEST_COMPANY_RECORD(state, payload) {
      state.getlatestrecord = payload;
    },
    SET_USER_COMPANY_ID(state, payload) {
      state.userCompanyId = payload;
    },
    SET_COMPANY_DETAIL(state, payload) {
      state.companyDetail = payload;
    },
    SET_USER_ROOT_COMPANY_ID(state, payload) {
      state.myParentCompany = payload;
    },
    GET_USER_COMPANY_NAME(state, payload) {
      state.userCompanyName = payload;
    },
    SET_LOCK_DOWN_STATUS(state, payload) {
      state.LockDownStatus = payload;
    },
    SET_USER_ACCOUNT_ACCESS(state, payload) {
      state.userAccAccess = payload;
    },
    SET_USER_SENTINELINSIGHT_ACCESS(state, payload) {
      state.viewSentinelInsightPerm = payload;
    },
    SET_USER_GENERATESTATEMENT_ACCESS(state, payload) {
      state.allowGenerateStatementPerm = payload;
    },
    GET_USER_COMPANY_STATUS(state, payload) {
      state.userCompanyStatus = payload;
    },
    GET_USER_COMPANY_PAYMENTCYCLE(state, payload) {
      state.paymentCycle = payload;
    },
    SET_USER_TEAM_LIST(state, payload) {
      state.getMyTeamList = payload;
    },
    GET_MY_TEAMS(state, payload) {
      state.myTeamList = payload;
    },
    GET_MY_ALL_TEAM(state, payload) {
      state.myAllTeamList = payload;
    },
    SET_ADD_TEAM_PERM(state, payload) {
      state.addTeamPerm = payload;
    },
    ADD_USER_TEAM_PERM_INFO(state, payload) {
      state.adduserRolePerms = payload;
    },
    SET_TEAM_LIST_USERS(state, payload) {
      state.getMyTeamListUser = payload;
    },
    GET_FORGET_MESSAGE(state, payload) {
      state.forgotPasswordMsg = payload;
    },
    GET_USER_PASS(state, payload) {
      state.getUserPass = payload;
    },
    UPDATE_USER_PASS(state, payload) {
      state.updatedUserPass = payload;
    },
    SET_USER_UPDATE(state, payload) {
      state.userDetailsUpdate = payload;
    },
    SET_PASSWORD_BY_ADMIN_NOTIFICATION(state, payload) {
      state.setPasswordByAdminReply = payload;
    },
    CHECK_USER_INFO(state, payload) {
      state.getUserInfoToCheck = payload;
    },
    SET_CREATE_NEW_COMPANY(state, payload) {
      state.showCreateNewChildCompany = payload;
    },
    SET_SUPPORT_ADMIN_ID(state, payload) {
      state.supportAdminId = payload;
    },
    GET_COMPANY_USER_LIST(state, payload) {
      state.companyUsersList = payload;
    },
    CONNECT_NEW_COMPANY_TO_USER(state, payload) {
      state.newCompanyToUserConnected = payload;
    },
    GET_ALL_USERS(state, payload) {
      state.allUsersRes = payload;
    },
    GET_USER_ASSIGNED_COMPANIES(state, payload) {
      state.userAssignedCompanies = payload;
    },
    SET_COMPANY_WISE_DATA(state, payload) {
      state.companyWiseExpense = payload;
    },
  },
  actions: {
    updateUser({ commit }, payload) {
      const Bdate1 = new Date(payload.birthDate);
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: USER_UPDATE_GQL,
          variables: {
            ...payload,
            birthDate: Bdate1,
          },
        })
        .then(({ data }) => {
          commit('SET_UPDATED_USER', data.updateUser);
          commit('UPDATE_USER_WITH_GR_LIST', data.updateUser);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    getStates({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_STATES_GQL,
        })
        .then(({ data }) => {
          commit('GET_STATES', data.states);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getStateserr => {
          console.log(getStateserr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    getCountries({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_COUNTRIES_GQL,
        })
        .then(({ data }) => {
          commit('GET_COUNTRIES', data.countries);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getCountrieserr => {
          console.log(getCountrieserr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // GET Business Types
    getBusinessType({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_INCORPORATION_TYPE_GQL,
        })
        .then(({ data }) => {
          commit('SET_BUSINESS_TYPE', data.incorporationTypes);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getBusinessTypeerr => {
          console.log(getBusinessTypeerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // GET Authorizing Officer
    getAuthorizedOfficer({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_AUTHORIZE_OFFICER_GQL,
        })
        .then(({ data }) => {
          commit('SET_AUTHORIZE_OFFICER', data.authorizeOfficers);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getAuthorizedOfficererr => {
          console.log(getAuthorizedOfficererr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    removeUser({ commit }, payload) {
      // clear token to prevent errors (if malformed)
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: USER_GR_UPDATE_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_GROUP_USER', data.removeUser);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(removeUsererr => {
          console.log(removeUsererr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    getUsers({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_USERS_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          commit('SET_USERS', data.users);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getUserserr => {
          console.log(getUserserr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    getUsersWithTeams({ commit }, payload) {
      let myCompany = '';
      let parentCompany = '';
      let signInCompany = null;
      commit('SET_ADD_USER_PERM', false);
      commit('SET_EDIT_USER_PERM', false);
      commit('SET_ADD_TEAM_PERM', false);
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      payload.companyId = localStorage.getItem('currentCompanyId');
  
      // Check if bulk transactions are enabled (but don't short circuit)
      const bulkTransactionsEnabled = isBulkTransactionsEnabled();
      if (bulkTransactionsEnabled) {
        console.log('Bulk Transactions: Still loading teams even with bulk transactions enabled');
        // Continue with API call instead of short-circuiting
      }
      apolloClient
        .query({
          query: GET_USER_MIN_INFO_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          if (localStorage.getItem('currentCompanyId')) {
            signInCompany = data.user.Company.find(item => item.id === localStorage.getItem('currentCompanyId'));
          } else if (payload.isParentChild) {
            signInCompany = data.user.Company.find(item => item.id === payload.companyId);
          } else {
            signInCompany = data.user.Company[0];
          }
          if (data.user.typeId === null || data.user.typeId === '') {
            const parent = data.user.Company.filter(item => item.isParent === true);
            if (parent.length) {
              parentCompany = parent[0].id;
              commit('SET_USER_ROOT_COMPANY_ID', parent[0].id);
            }


            if (signInCompany.isLockDown && signInCompany.LockDownStatus) {
              commit('SET_LOCK_DOWN_STATUS', true);
            }
            commit('GET_USER_COMPANY_STATUS', signInCompany.status);
            commit('GET_USER_COMPANY_NAME', signInCompany.companyName);
            commit('SET_USER_COMPANY_ID', signInCompany.id);
            myCompany = signInCompany.id;
            commit('SET_COMPANY_DETAIL', signInCompany);
            commit('GET_USER_COMPANY_PAYMENTCYCLE', signInCompany.paymentCycle);
            commit('SET_USER_ACCOUNT_ACCESS', data.user.UserSettings[0].accountAccess);
            commit('SET_USER_SENTINELINSIGHT_ACCESS', data.user.UserSettings[0].viewSentinelInsightPerm);
            commit('SET_USER_GENERATESTATEMENT_ACCESS', data.user.UserSettings[0].allowGenerateStatementPerm);
          }
          const teamList = [];
          const myTeamList = data.user.teams;
          const payload1 = {};
          if (data.user.UserSettings.length > 0) {
            if (!data.user.UserSettings[0].isExternalUser) {
            // When user is invited from different company in
            // that case we will not apply below condition.
              if (parentCompany !== myCompany) {
                payload1.isChild = true;
              }
            }
          }

          let queryVar = '';
          let flag = 1;
          let teamInfo = [];
          commit('SET_USER_TEAM_LIST', myTeamList);
          data.user.teams.forEach((permission) => {
            const i = [];
            teamList.push(permission.team.id);
            if (permission.team.groupName === 'All Teams') {
              flag = 2;
            } else {
              teamInfo.push(permission.team);
            }
            permission.permissions.forEach((perm) => {
              // To Avoid perm.slug undefine issue.
              if (perm) {
                if (perm.slug === 'edit_employee') {
                  commit('SET_EDIT_USER_PERM', true);
                }
                if (perm.slug === 'create_employee') {
                  commit('SET_ADD_USER_PERM', true);
                }
                if (perm.slug === 'create_team') {
                  commit('SET_ADD_TEAM_PERM', true);
                }
                i.push(perm.id);
              }
            });
            // Override permission in case of ALLAdmin permission;
            if (data.user.UserSettings.length > 0) {
              if (data.user.UserSettings[0].isAllCompanyAdmin) {
                commit('SET_EDIT_USER_PERM', true);
                commit('SET_ADD_USER_PERM', true);
                commit('SET_ADD_TEAM_PERM', true);
              }
            }

            permission.permissions2 = permission.permissions;
            permission.permissions = i;
          });
          if (data.user.typeId === null || data.user.typeId === '') {
            payload1.companyId = signInCompany.id;
            
            // For bulk transactions, we want to get teams but skip user queries
            const bulkTransactionsEnabled = isBulkTransactionsEnabled();
            
            if (teamList.length > 0 && flag === 1) {
              payload1.teams = teamList;
              queryVar = GET_TEAM_USERS_GQL;
              const teamInfo1 = teamInfo.sort((a, b) => a.groupName.localeCompare(b.groupName));
              // Filter Team  (1 or 3)
              commit('GET_MY_TEAMS', teamInfo1);
            } else {
              queryVar = GET_TEAM_USERS_GQL2;
              apolloClient
                .query({
                  query: GET_GROUP_LIST_GQL,
                  variables: {
                    recordStatus: 1,
                    flag: 1,
                    // companyId: data.user.Company[0].id,
                    companyId: signInCompany.id,
                  },
                  fetchPolicy: 'network-only',
                })
                .then((mydata) => {
                  teamInfo = mydata.data.groups;
                  const teamInfo1 = teamInfo.sort((a, b) => a.groupName.localeCompare(b.groupName));
                  // Filter Team  (1 or 3)
                  const ActiveTeams = teamInfo1.filter(item => item.recordStatus === 1);
                  commit('GET_MY_TEAMS', ActiveTeams);
                  commit('GET_MY_ALL_TEAM', teamInfo1);
                  
                  // If bulk transactions enabled, skip the user query and finish here
                  if (bulkTransactionsEnabled) {
                    console.log('Bulk Transactions: Skipping user queries but keeping team data');
                    commit('shared/SET_LOADING', false, { root: true });
                  }
                });
            }
            
            // Skip user queries if bulk transactions enabled
            if (bulkTransactionsEnabled) {
              console.log('Bulk Transactions: Skipping user queries');
              return;
            }
            
            // Inactive Users - Only run this if not bulk transactions
            apolloClient
              .query({
                query: queryVar,
                variables: {
                  ...payload1,
                  // status: false,
                },
                fetchPolicy: 'network-only',
              })
              .then((userdata) => {
                const inactiveUsers = userdata.data.users.filter((user) => (user.UserSettings[0].status === false));
                // SH-290
                const sorted = inactiveUsers.sort((a, b) => a.firstName.localeCompare(b.firstName));
                sorted.forEach(item => {
                  item.teams.sort((a, b) => a.team.groupName.localeCompare(b.team.groupName));
                });
                // Arrange in alphabetical order
                commit('GET_USER_WITH_GR_LIST_INACTIVE', sorted);
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
              })
              .catch(myerr => {
                console.log(myerr);
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
              });
            // Active Users
            apolloClient
              .query({
                query: queryVar,
                variables: {
                  ...payload1,
                },
                fetchPolicy: 'network-only',
              })
              .then((userdata) => {
                // SH-290
                const activeUsers = userdata.data.users.filter((user) => (user.UserSettings[0].status));
                const sorted = activeUsers.sort((a, b) => a.firstName.localeCompare(b.firstName));
                sorted.forEach(item => {
                  item.teams.sort((a, b) => a.team.groupName.localeCompare(b.team.groupName));
                });
                // Arrange in alphabetical order
                commit('GET_USER_WITH_GR_LIST', sorted);
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
              })
              .catch(getUsersWithTeamserr => {
                console.log(getUsersWithTeamserr);
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
              });
          }
        })
        .catch(getUsersWithTeamerr => {
          console.log(getUsersWithTeamerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getCurrentUser({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_CURRENT_USER,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('SET_CURRENT_USERS', data.user);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getCurrentUsererr => {
          console.log(getCurrentUsererr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async avatarUploadImage({ commit }, payload) {
      if (payload.userPhoto !== '') {
        const AWS = require('aws-sdk');
        const s3bucket = new AWS.S3({
          accessKeyId: process.env.VUE_APP_AWS_IAM_USER_KEY,
          secretAccessKey: process.env.VUE_APP_AWS_IAM_USER_SECRET,
          Bucket: process.env.VUE_APP_BUCKET_NAME,
        });
        const avatarName = `${payload.firstName.replace(/\s+/g, '-').toLowerCase()}${new Date().getTime()}`;
        const contentType = payload.userPhoto.type;
        const type = contentType.split('/').pop();
        const file = new File([payload.userPhoto], `${avatarName}.${type}`);
        const acl = 'public-read';
        const newFileName = `${avatarName}.${type}`;
        const usrIdObj = payload.id;
        const objkey = `${usrIdObj}/${newFileName}`;
        const contentDeposition = `inline;filename="${objkey}"`;
        s3bucket.createBucket(() => {
          const params = {
            Bucket: process.env.VUE_APP_BUCKET_NAME,
            Key: objkey,
            Body: file,
            ContentDisposition: contentDeposition,
            ContentType: contentType,
            ACL: acl,
          };
          s3bucket.upload(params, (err, data) => {
            if (err) {
              console.log(err);
            }
            payload.userPhoto = data.Location;
            apolloClient
              .mutate({
                mutation: UPDATE_USER_AVATAR_GQL,
                variables: {
                  id: payload.id,
                  userPhoto: payload.userPhoto,
                },
              })
              .then((avatarData) => {
                commit('SET_AVATAR', avatarData.data);
                commit('SET_AVATAR_LEFT_PANEL', avatarData.data.updateAvatar);
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
              })
              .catch((err1) => {
                console.log(err1);
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
              });
            commit('shared/SET_LOADING', true, {
              root: true,
            });
          });
        });
      }
    },
    async updateUserdetail({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_USER_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          const updateResult = data.updateUser;
          updateResult.message = 'User settings updated successfully.';
          commit('SET_USER_UPDATE', updateResult);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(updateUserdetailerr => {
          console.log(updateUserdetailerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async signInUser({ commit }, payload) {
      const ms = [];
      const dateObj = new Date();
      const timeStamp = dateObj.getTime().toString();
      // in the case of PatentChild company;
      // incase of Masquerade
      if (payload.maskid) {
        await apolloClient
          .mutate({
            mutation: SIGNIN_USER_GQL,
            variables: payload,
          })
          .then(({ data }) => {
            localStorage.setItem('token', data.token);
            localStorage.setItem('isMask', 'yes');
            const userInfo = data;
            ms[0] = userInfo.signInUser;
            ms[1] = timeStamp;
            localStorage.setItem('userType', data.signInUser.user.typeId);
            localStorage.setItem('userTypeAllCompany', data.signInUser.user.UserSettings[0].isAllCompanyAdmin);
            commit('SET_SIGNED_IN_USER', ms);
            commit('SET_ME', userInfo.signInUser.user);

            commit('SET_AVATAR', data.signInUser.user.userPhoto);
            localStorage.setItem('token', data.signInUser.token);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          })
        // eslint-disable-next-line arrow-parens
          .catch((err) => {
            console.log(err);
            ms[0] = 'Invalid';
            ms[1] = timeStamp;
            commit('SET_SIGNED_IN_USER', ms);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          });
        return 'return Masquerade login';
      }
      // clear token to prevent errors (if malformed)
      localStorage.setItem('token', '');
      localStorage.setItem('userType', '');
      localStorage.setItem('isMask', '');
      localStorage.setItem('userTypeAllCompany', '');
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      const token = await SignIn(payload.email, payload.password)
        .then(async msg => {
          // Validate from node server as well, Redirect to home page usign token.
          // msg contain tokens
          // Payload contain User data commign form Signin.vue
          await apolloClient
            .mutate({
              mutation: SIGNIN_USER_GQL,
              variables: payload,
            })
            .then(({ data }) => {
              localStorage.setItem('token', data.token);
              localStorage.setItem('isMask', '');
              const userInfo = data;
              ms[0] = userInfo.signInUser;
              ms[1] = timeStamp;
              localStorage.setItem('userType', data.signInUser.user.typeId);
              if (!data.signInUser.user.typeId) {
                localStorage.setItem('userTypeAllCompany', data.signInUser.user.UserSettings[0].isAllCompanyAdmin);
              }
              commit('SET_SIGNED_IN_USER', ms);
              commit('SET_ME', userInfo.signInUser.user);
              commit('SET_AVATAR', data.signInUser.user.userPhoto);
              localStorage.setItem('token', data.signInUser.token);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            // eslint-disable-next-line arrow-parens
            .catch((signInUsererr) => {
              console.log(signInUsererr);
              ms[0] = 'Invalid';
              ms[1] = timeStamp;
              commit('SET_SIGNED_IN_USER', ms);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
          return msg;
        })
        .catch((msg) => {
          console.log(msg);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          ms[0] = 'Invalid';
          ms[1] = timeStamp;
          ms[2] = msg;
          commit('SET_SIGNED_IN_USER', ms);
        });
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      return token;
    },

    async forgetPasswordconfm({ commit }, payload) {
      await AwsConfirmPassword(payload.email, payload.code, payload.password);
      apolloClient
        .mutate({
          mutation: FORGET_USER_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('GET_FORGET_MESSAGE', data.forgetPassword);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log('Err@forgetPassword');
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // Sign up User and Create company
    async signUpUser({ commit }, payload) {
      // clear token to prevent errors (if malformed)
      if (payload.isDisconnectBusinessObject !== true) {
        localStorage.setItem('token', '');
        localStorage.setItem('userType', '');
        localStorage.setItem('isMask', '');
        localStorage.setItem('userTypeAllCompany', '');
      }
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      commit('shared/SET_SIGNUP_ONOFF', true, {
        root: true,
      });
      // Create user at cognito
      await RegisterUser(payload)
        .then(() => {
          // Push demographic information to node server.
          apolloClient
            .mutate({
              mutation: SIGNUP_USER_GQL2,
              variables: payload,
            })
            .then(({ data }) => {
              payload.userId = data.createUser.id;
              apolloClient
                .mutate({
                  mutation: SIGNUP_BUSINESS_GQL,
                  variables: payload,
                })
                .then((CreateCompanyData) => {
                  commit('SET_SIGNED_UP_USER', CreateCompanyData.data.createCompany);
                  commit('shared/SET_SIGNUP_ONOFF', false, {
                    root: true,
                  });
                  apolloClient
                    .mutate({
                      mutation: SET_USER_SETTING_GQL,
                      variables: {
                        isAdmin: payload.isAdmin,
                        accountAccess: payload.accountAccess,
                        isCompanyAdmin: payload.isCompanyAdmin,
                        accountingSystemAccess: payload.accountingSystemAccess,
                        viewSentinelInsightPerm: true,
                        allowGenerateStatementPerm: true,
                        companyId: CreateCompanyData.data.createCompany.id,
                        userId: payload.userId,
                      },
                    })
                    .then(() => {
                      commit('shared/SET_LOADING', false, {
                        root: true,
                      });
                    }).catch(err => {
                      console.log(err.message);
                      commit('shared/SET_LOADING', false, {
                        root: true,
                      });
                      commit('SET_MESSAGE', err);
                    });
                })
                .catch(err => {
                  console.log(err.message);
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                  commit('shared/SET_SIGNUP_ONOFF', false, {
                    root: true,
                  });
                  commit('SET_MESSAGE', err);
                });
            })
            .catch(msg => {
              // Throw Error from Cognito server.
              commit('SET_MESSAGE', msg);
              commit('shared/SET_SIGNUP_ONOFF', false, {
                root: true,
              });
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        }).catch(msgerr => {
          // Throw Error from Cognito server.
          commit('SET_MESSAGE', msgerr);
          commit('shared/SET_SIGNUP_ONOFF', false, {
            root: true,
          });
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async signUpChildCompany({ commit }, payload) {
      // clear token to prevent errors (if malformed)
      if (payload.isDisconnectBusinessObject !== true) {
        localStorage.setItem('token', '');
        localStorage.setItem('userType', '');
        localStorage.setItem('isMask', '');
        localStorage.setItem('userTypeAllCompany', '');
      }
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      commit('shared/SET_SIGNUP_ONOFF', true, {
        root: true,
      });
      payload.userId = payload.parentUserId;
      apolloClient
        .mutate({
          mutation: SIGNUP_BUSINESS_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_SIGNED_UP_USER', data.createCompany);
          commit('shared/SET_SIGNUP_ONOFF', false, {
            root: true,
          });
          apolloClient
            .mutate({
              mutation: SET_USER_SETTING_GQL,
              variables: {
                status: true,
                isVerify: true,
                isAdmin: payload.isAdmin,
                accountAccess: payload.accountAccess,
                isCompanyAdmin: payload.isCompanyAdmin,
                accountingSystemAccess: payload.accountingSystemAccess,
                viewSentinelInsightPerm: true,
                allowGenerateStatementPerm: true,
                companyId: data.createCompany.id,
                userId: payload.userId,
                attachChildCompanyToUser: true,
                isAllCompanyAdmin: payload.isAllCompanyAdmin,
              },
            })
            .then(() => {
              commit('shared/SET_LOADING', false, { root: true });
            }).catch(Msgerr => {
              console.log(Msgerr.message);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              commit('SET_MESSAGE', Msgerr);
            });
        })
        .catch(signUpChildCompanyerr => {
          console.log(signUpChildCompanyerr.message);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('shared/SET_SIGNUP_ONOFF', false, {
            root: true,
          });
          commit('SET_MESSAGE', signUpChildCompanyerr);
        });
    },

    async getUserInfoFromEmail({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_USER_INFO_FROM_EMAIL_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          if (data.user && payload.signInCase) {
            if (payload.signInCase) {
              delete payload.signInCase;
            }
            // Makes request in cognito to verify whether email is verified in cognito or not
            CheckEmailVerificationStatus(
              payload.email,
            ).catch((err) => {
              data.user.resendEmail = false;
              if (err.code === 'UserNotConfirmedException') {
              // Email not verified in cognito
                data.user.resendEmail = true;
                if (data.user.UserSettings.length === 1 && !data.user.UserSettings[0].isVerify) {
                // New user case
                  reVerifyUser({
                    id: payload.email,
                  })
                    .then(() => {
                      commit('GET_USER_INFO_FROM_EMAIL', { data: data.user, uniqueId: moment.now() });
                      commit('shared/SET_LOADING', false, { root: true });
                    })
                    .catch((resendErr) => {
                      data.user.resendErr = resendErr;
                      commit('GET_USER_INFO_FROM_EMAIL', { data: data.user, uniqueId: moment.now() });
                      commit('shared/SET_LOADING', false, {
                        root: true,
                      });
                    });
                } else {
                // // edit case
                  reVerifyUser({
                    id: payload.email,
                    updateEmailCase: true,
                  })
                    .then(() => {
                      commit('GET_USER_INFO_FROM_EMAIL', { data: data.user, uniqueId: moment.now() });
                      commit('shared/SET_LOADING', false, { root: true });
                    })
                    .catch((editCaseResendErr) => {
                      data.user.resendErr = editCaseResendErr;
                      commit('GET_USER_INFO_FROM_EMAIL', { data: data.user, uniqueId: moment.now() });
                      commit('shared/SET_LOADING', false, {
                        root: true,
                      });
                    });
                }
              } else {
              // Normal case
                commit('GET_USER_INFO_FROM_EMAIL', { data: data.user, uniqueId: moment.now() });
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
              }
            });
          } else {
            commit('GET_USER_INFO_FROM_EMAIL', { data: data.user, uniqueId: moment.now() });
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          }
        })
        .catch(() => {
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async signUpUser1({ commit }, payload) {
      // clear token to prevent errors (if malformed)
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      // Create user at cognito
      await RegisterUser(payload)
        .then(() => {
          // Push demographic information to node server.
          apolloClient
            .mutate({
              mutation: SIGNUP_USER_GQL,
              variables: payload,
            })
            .then(({ data }) => {
              commit('SET_SIGNED_UP_USER', data.createUser);
              commit('ADD_USER_LEFT_PANEL', data.createUser);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch(RegisterUsererr => {
              console.log(RegisterUsererr.message);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              commit('SET_MESSAGE', RegisterUsererr);
            });
        })
        .catch(msg => {
          // Throw Error from Cognito server.
          commit('SET_MESSAGE', msg);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },


    async getMe({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      await apolloClient
        .query({
          query: GET_ME_GQL,
          fetchPolicy: 'no-cache',
        })
        .then(async ({ data }) => {
          data.me.uniqueId = moment.now();
          const currentCompanyId = localStorage.getItem('currentCompanyId');
          if (currentCompanyId) {
            const userSettings = setTransactionHeader(data.me.UserSettings, currentCompanyId);
            data.me.currentCompUserSettings = userSettings;
          }


          if (data.me.Company.length) {
            data.me.parentChildCompany = [];
            const currentCompany = data.me.currentCompUserSettings[0].companyId;
            // currentCompany
            data.me.myCompany = data.me.Company.filter(cmp => cmp.id === currentCompany);
            const parentCompnay = getParentCompany(data.me.Company, currentCompany);
            const companyList = getCompanyListBasedOnParent(data.me.Company, parentCompnay);
            const companyListFinal = [...new Set(companyList)];
            data.me.UserSettings.forEach(userSetting => {
              if (companyListFinal.includes(userSetting.companyId)) {
                const company = data.me.Company.filter(cmp => cmp.id === userSetting.companyId);
                if (company[0]) {
                  data.me.parentChildCompany.push(company[0]);
                }
              }
            });
          }
          // to make unique company;

          data.me.parentChildCompany = [...new Set(data.me.parentChildCompany)];
          commit('SET_ME', data.me);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(() => {
          commit('CLEAR_ME');
          localStorage.setItem('token', '');
          localStorage.setItem('isMask', '');
          localStorage.setItem('userTypeAllCompany', '');
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async signInChild({ _commit }, _payload) {
      console.log('login again');
    },

    async signOutMe({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      // reset pagination to default value
      localStorage.setItem('pagination', 5);
      // end session
      apolloClient
        .mutate({
          mutation: SET_LOGOUT_TIME_GQL,
          variables: {
            token: localStorage.getItem('token'),
            companyId: localStorage.getItem('currentCompanyId'),
          },
        })
        .then(async () => {
          await apolloClient.resetStore().then(() => {
            // redirect to sign-in
            // payload has value vue's this.$router
            localStorage.setItem('token', '');
            localStorage.setItem('userType', '');
            localStorage.setItem('isMask', '');
            localStorage.setItem('userTypeAllCompany', '');
            payload.push('/sign-in');
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          });
          // clear user in state
          commit('CLEAR_ME');
          // remove token from localStorage
          localStorage.setItem('token', '');
          localStorage.setItem('userType', '');
          localStorage.setItem('isMask', '');
          localStorage.setItem('userTypeAllCompany', '');
          // remember password feature needs the "token"
          // so keep it empty rather completely removing it.
        })
        .catch(signOutMeerr => {
          console.log(signOutMeerr.message);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('SET_MESSAGE', err);
        });
    },

    async resetPassword({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await AwsChangePassword(payload.email, payload.olduserPass, payload.newuserPass)
        .then(msg => {
          commit('SET_CHANGEPASSWORD_NOTIFICATION', {
            Message: msg,
          });
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_CHANGEPASSWORD_NOTIFICATION', {
            Message: err.message,
          });
        });
    },
    getUserInfo({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_USER_INFO_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          data.user.teams.forEach((permission) => {
            const i = [];
            permission.team.slug = permission.team.groupName.replace(/\s+/g, '-').toLowerCase();
            permission.permissions.forEach((id) => {
              i.push(id.id);
            });
            permission.permissions = i;
          });
          commit('GET_USER_INFO', data.user);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getUserInfoerr => {
          console.log(getUserInfoerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getUserGroupBudget({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      await apolloClient
        .query({
          query: GET_USER_GROUP_BUDGET_INFO_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          data.user.teams.forEach((permission) => {
            const i = [];
            permission.team.slug = permission.team.groupName.replace(/\s+/g, '-').toLowerCase();
            permission.permissions.forEach((id) => {
              if (id != null) { i.push(id.id); }
            });
            permission.permissions = i;
          });

          commit('GET_USER_GROUP_BUDGET_INFO', data.user);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getUserGroupBudgeterr => {
          console.log(getUserGroupBudgeterr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getUserInfoCard({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      await apolloClient
        .query({
          query: GET_USER_INFO_GQL_CARD,
          variables: payload,
        })
        .then(({ data }) => {
          commit('GET_USER_CARD_INFO', data.user);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getUserInfoCarderr => {
          console.log(getUserInfoCarderr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    resetEmployee({ commit }) {
      initEmployee.teams = [];
      commit('GET_USER_INFO', Object.assign({}, initEmployee));
    },
    getUserMinInfo({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_USER_MIN_INFO_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          data.user.teams.forEach((mypermission) => {
            const i = [];
            mypermission.team.slug = mypermission.team.groupName.replace(/\s+/g, '-').toLowerCase();
            mypermission.permissions.forEach((id) => {
              i.push(id.id);
            });
            mypermission.permissions = i;
          });

          commit('GET_USER_MIN_INFO', data.user);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getUserMinInfoerr => {
          console.log(getUserMinInfoerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    addTeamUserPerms({ commit }, payload) {
      console.log('addTeamUserPerms', payload);
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: U_PERM_TEAM_CONNECT_GQL,
          variables: {
            userId: payload.userId,
            roleId: payload.roleId,
            overrideDefaultPermissions: payload.overrideDefaultPermissions,
            teamId: payload.teamId,
            permId: payload.permId,
            companyId: payload.companyId,
          },
        })
        .then(({ data }) => {
          commit('ADD_USER_TEAM_PERM_INFO', data.createTeamToUser);
          commit('SET_USER_TEAM_LEFT_PANEL', data.createTeamToUser);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    getTeamUsersAvatar({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
  
      // Skip API call and return empty data if bulk transactions is enabled
      if (isBulkTransactionsEnabled()) {
        console.log('Bulk Transactions: Skipping getTeamUsersAvatar API call');
        commit('SET_TEAM_LIST_USERS', []);
        commit('shared/SET_LOADING', false, { root: true });
        return;
      }
  
      apolloClient
        .query({
          query: GET_USERS_LIST_FOR_TEAM,
          variables: payload,
        })
        .then(({ data }) => {
          const teamArray = [];
          data.teamToUsersList.forEach(element => {
            const teamObject = {};
            const chkLngth = teamArray.filter(team => team.team.id === element.team.id);
            if (chkLngth.length === 0) {
              const userArray = [];
              teamObject.id = element.team.id;
              teamObject.groupName = element.team.groupName;
              if (element.user !== null) {
                userArray.push(element.user);
                teamObject.users = userArray;
                const teamObj = { team: teamObject };
                teamArray.push(teamObj);
              }
            } else {
              const indexTeam = teamArray.findIndex(team => team.team.id === element.team.id);

              if (element.user !== null) {
                // eslint-disable-next-line max-len
                const userChk = teamArray[indexTeam].team.users.filter(user => user.id === element.user.id);
                if (userChk.length === 0) {
                  teamArray[indexTeam].team.users.push(element.user);
                }
              }
            }
          });
          commit('SET_TEAM_LIST_USERS', teamArray);

          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async fngetAllUsers({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_ADMIN_INFO_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          const userWithAccountAccess = [];
          const userWithoutAccountAccess = [];
          data.users.forEach((user) => {
            if (user.UserSettings.length > 0) {
              if (user.UserSettings[0].accountAccess) {
                userWithAccountAccess.push(user);
              } else {
                userWithoutAccountAccess.push(user);
              }
            }
          });
          data.users = userWithAccountAccess.concat(userWithoutAccountAccess);
          commit('GET_ADMIN_USER', data.users);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(fngetAllUserserr => {
          console.log(fngetAllUserserr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async fnGetUserPass({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      const AWS = require('aws-sdk');
      const kms = new AWS.KMS({
        accessKeyId: process.env.VUE_APP_AWS_IAM_USER_KEY,
        secretAccessKey: process.env.VUE_APP_AWS_IAM_USER_SECRET,
        region: 'us-east-1',
      });
      await apolloClient
        .query({
          query: GET_USER_PASS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(async ({ data }) => {
            // Decrypt the password using AWS KMS
          const params = {
            CiphertextBlob: Buffer.from(data.user.password, 'base64'), // Decode Base64 to Buffer
          };
      
          const result = await kms.decrypt(params).promise();
          const decryptedPassword = result.Plaintext.toString('utf-8'); // Convert plaintext to string
      
            // Add decrypted password to the user object
          data.user.password = decryptedPassword;
      
          commit('GET_USER_PASS', data.user);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(fnGetUserPasserr => {
          console.log(fnGetUserPasserr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    updateUserPass({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_USER_PASS_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('UPDATE_USER_PASS', data.updateUserPass);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(updateUserPasserr => {
          console.log(updateUserPasserr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    updateStagusOfEmployee({ commit }, payload) {
      console.log('updateStagusOfEmployee', payload);
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_USER_SETTING_GQL,
          variables: payload,
        })
        .then(() => {
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(updateStagusOfEmployeeErr => {
          console.log(updateStagusOfEmployeeErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    updateInvitationDate({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_USER_INVITATION_DATE_GQL,
          variables: payload,
        })
        .then(() => {
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(updateInvitationDateerr => {
          console.log(updateInvitationDateerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // change user's password from admin
    async resetPasswordByAdmin({ commit }, payload) {
      await AwsChangePasswordByAdmin(payload.email, payload.password)
        .then(msg => {
          commit('SET_PASSWORD_BY_ADMIN_NOTIFICATION', {
            Message: msg,
          });
        })
        .catch(err => {
          commit('SET_PASSWORD_BY_ADMIN_NOTIFICATION', {
            Message: err.message,
          });
        });
    },


    // Check user status
    async fnCheckUserInfo({ commit }, payload) {
      const ms = [];
      const dateObj = new Date();
      const timeStamp = dateObj.getTime().toString();
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      payload.companyId = localStorage.getItem('currentCompanyId');
      await apolloClient
        .query({
          query: CHECK_USER_INFO_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          ms[0] = data;
          ms[1] = timeStamp;
          commit('CHECK_USER_INFO', ms);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(fnCheckUserInfoerr => {
          console.log(fnCheckUserInfoerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // Sign-in via OTP
    async signInUserByCode({ commit }, payload) {
      const ms = [];
      const dateObj = new Date();
      const timeStamp = dateObj.getTime().toString();

      await apolloClient
        .mutate({
          mutation: SIGNIN_USER_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          localStorage.setItem('token', data.token);
          localStorage.setItem('isMask', '');
          const userInfo = data;
          ms[0] = userInfo.signInUser;
          ms[1] = timeStamp;
          localStorage.setItem('userType', data.signInUser.user.typeId);
          localStorage.setItem('userTypeAllCompany', data.signInUser.user.UserSettings[0].isAllCompanyAdmin);
          commit('SET_SIGNED_IN_USER', ms);
          commit('SET_ME', userInfo.signInUser.user);

          commit('SET_AVATAR', data.signInUser.user.userPhoto);
          localStorage.setItem('token', data.signInUser.token);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        // eslint-disable-next-line arrow-parens
        .catch((retrunerr) => {
          console.log(retrunerr);
          ms[0] = 'Invalid';
          ms[1] = timeStamp;
          commit('SET_SIGNED_IN_USER', ms);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async updateEmailInCognito({ commit }, payload) {
      payload.updateEmailCase = true;
      await RegisterUser(payload)
        .then(() => {
          delete payload.updateEmailCase;
          awsDeleteMailCognito(payload);
        })
        .catch(updateEmailInCognitomsg => {
          commit('SET_MESSAGE', updateEmailInCognitomsg);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async newCompany({ commit }, payload) {
      commit('SET_CREATE_NEW_COMPANY', payload.visible);
    },

    async addSupportAdmin({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await RegisterUser(payload)
        .then(() => {
          apolloClient
            .mutate({
              mutation: SET_ADD_SUPPORT_ADMIN_GQL,
              variables: payload,
            })
            .then(({ data }) => {
              commit('SET_SUPPORT_ADMIN_ID', data.createUser);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch(addSupportAdminerr => {
              console.log(addSupportAdminerr.message);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              commit('SET_MESSAGE', err);
            });
        })
        .catch(msg => {
          // Throw Error from Cognito server.
          console.log(msg);
          commit('SET_MESSAGE', msg);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async updateSupportAdmin({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_REMOVE_PREVIOUS_PERMISSIONS_SELECTION_GQL,
          variables: {
            previouslyAssignedPermissions: payload.previouslyAssignedPermissions,
            supportAdminId: payload.supportAdminId,
          },
        })
        .then(() => {
          apolloClient
            .mutate({
              mutation: SET_UPDATE_SUPPORT_ADMIN_GQL,
              variables: payload,
            })
            .then(({ data }) => {
              commit('SET_SUPPORT_ADMIN_ID', data.updateUser);
            })
            .catch(err => {
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              commit('SET_MESSAGE', err);
            });
        })
        .catch(updateSupportAdminerr => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('SET_MESSAGE', updateSupportAdminerr);
        });
    },
    async toggleSupportAdminStatus({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_TOGGLE_SUPPORT_ADMIN_STATUS_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_SUPPORT_ADMIN_ID', data.updateUser);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(toggleSupportAdminStatuserr => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('SET_MESSAGE', toggleSupportAdminStatuserr);
        });
    },
    async sendSupportMail({ commit }, payload) {
      apolloClient
        .query({
          query: SEND_MESSAGE,
          variables: payload,
        })
        .then(() => {
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(sendSupportMailerr => {
          console.log(sendSupportMailerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async getCompanyUserList({ commit }, payload) {
      apolloClient
        .query({
          query: GET_COMPANY_USER_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          const userList = [];
          data.company.users.forEach((user) => {
            if (user.UserSettings.length > 0) {
              if (user.UserSettings.length > 0) {
                userList.push(user);
              }
            }
          });
          data.company.users = userList;
          commit('GET_COMPANY_USER_LIST', data.company.users);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(getCompanyUserListerr => {
          console.log(getCompanyUserListerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async activateEmployeeForCompany({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_ACTIVATE_EMPLOYEE_FOR_COMPANY_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_ACTIVATE_EMPLOYEE_FOR_COMPANY', { data: data.activateEmployeeForCompany, uniqueId: moment.now() });
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(activateEmployeeForCompanyerr => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('SET_MESSAGE', activateEmployeeForCompanyerr);
        });
    },
    async removeUserFromCompany({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_REMOVE_USER_FROM_COMPANY_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_REMOVE_USER_FROM_COMPANY', { data: data.removeUserFromCompany, uniqueId: moment.now() });
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(removeUserFromCompanyerr => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('SET_MESSAGE', removeUserFromCompanyerr);
        });
    },
    async connectNewCompanyToUser({ commit }, payload) {
      console.log(payload);
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      // Performs db opration.
      apolloClient
        .mutate({
          mutation: CONNECT_NEW_COMPANY_TO_USER_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          // Sends email
          commit('SET_SIGNED_UP_USER', data.connectNewCompanyToUser);
          commit('ADD_INACTIVE_USER_LEFT_PANEL', data.connectNewCompanyToUser);
          commit('CONNECT_NEW_COMPANY_TO_USER', data.connectNewCompanyToUser);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(connectNewCompanyToUsererr => {
          console.log('connectNewCompanyToUsererr', connectNewCompanyToUsererr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('SET_MESSAGE', connectNewCompanyToUsererr);
        });
    },
    async verifyInvitation({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: VERIFY_INVITATION_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          // Sends email
          commit('VERIFY_INVITATION', data.verifyInvitation);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(verifyInvitationerr => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('SET_MESSAGE', verifyInvitationerr);
        });
    },
    async setNewUserEmail({ commit }, payload) {
      commit('SET_NEW_USER_EMAIL', payload.email);
    },
    startLoaderFromVueFile({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
    },
    endLoaderFromVueFile({ commit }) {
      commit('shared/SET_LOADING', false, { root: true });
    },
    updateCompanyAdmin({ commit }, payload) {
      // disable company admins
      // Set company admin
      // Update company email
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_UPDATE_COMPANY_ADMIN_GQL,
          variables: payload,
        })
        .then((updateCompanyAdminData) => {
          commit('SET_USER_UPDATE', updateCompanyAdminData.data.updateCompanyAdmin);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(updateCompanyAdminErr => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('SET_MESSAGE', updateCompanyAdminErr);
        });
    },
    updateCreatingSubCompanyStatus({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_UPDATE_CREATING_SUB_COMPANY_STATUS_GQL,
          variables: payload,
        })
        .then((updateCreatingSubCompanyStatusData) => {
          commit('SET_USER_UPDATE', updateCreatingSubCompanyStatusData.data.updateCreatingSubCompanyStatus);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(updateCreatingSubCompanyStatusErr => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('SET_MESSAGE', updateCreatingSubCompanyStatusErr);
        });
    },
    async getAllUsers({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_ALL_USERS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getAllUsersData) => {
          commit('GET_ALL_USERS', getAllUsersData.data.getAllUsers);
        })
        .catch(getAllUsersErr => {
          commit('GET_ALL_USERS', { status: 'failure', error: getAllUsersErr.message });
        });
    },

    async getCompanywiseExpense({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_COMAPANY_WISE_EXPENSE,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getCompanywiseExpenseData) => {
          commit('SET_COMPANY_WISE_DATA', getCompanywiseExpenseData.data.getCompanyWiseExpense);
        })
        .catch(getCompanywiseExpenseErr => {
          commit('SET_COMPANY_WISE_DATA', { status: 'failure', error: getCompanywiseExpenseErr.message });
        });
    },

    async getUserAssignedCompanies({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_USER_ASSIGNED_COMPANIES_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getUserAssignedCompaniesData) => {
          commit('GET_USER_ASSIGNED_COMPANIES', getUserAssignedCompaniesData.data.getUserAssignedCompanies);
        })
        .catch(getUserAssignedCompaniesErr => {
          commit('GET_USER_ASSIGNED_COMPANIES', { status: 'failure', error: getUserAssignedCompaniesErr.message });
        });
    },

    async signInUserByCodeForSuperAndSupportAdmin({ commit }, payload) {
      const message = [];
      const dateObj = new Date();
      const timeStamp = dateObj.getTime().toString();

      await apolloClient
        .query({
          query: SIGNIN_USER_GQL_FOR_SUPER,
          variables: payload,
        })
        .then((userInfo) => {
          // set token to local storage to redirect on dashbord sreen on refresh;
          localStorage.setItem('token', userInfo.data.signInSuperAdminUsingLink.token);
          localStorage.setItem('isMask', '');
          localStorage.setItem('userType', userInfo.data.signInSuperAdminUsingLink.user.typeId);

          // prepared message for put in store;
          message[0] = userInfo.data.signInSuperAdminUsingLink;
          message[1] = timeStamp;

          commit('SET_SIGNED_IN_USER_SUPER_ADMIN', message);
          commit('SET_ME', userInfo.data.signInSuperAdminUsingLink.user);
          commit('SET_AVATAR', userInfo.data.signInSuperAdminUsingLink.user.userPhoto);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        // eslint-disable-next-line arrow-parens
        .catch((retrunerr) => {
          console.log(retrunerr);
          message[0] = 'Invalid';
          message[1] = timeStamp;
          commit('SET_SIGNED_IN_USER', message);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
  },

  getters: {
    // = computed properties
    users: state => state.users,
    me: state => state.me,
    signedInUser: state => state.signedInUser,
    signedInUserSuperAdmin: state => state.signedInUserSuperAdmin,
    signedUpUser: state => state.signedUpUser,
    email: state => state.email,
    message: state => state.message,
    currentuser: state => state.currentuser,
    updatedUser: state => state.updatedUser,
    removedGroup: state => state.removedGroup,
    changePasswordreply: state => state.changePasswordreply,
    getAllUserList: state => state.getAllUserList,
    getSelUserList: state => state.getSelUserList,
    getUserWithGrList: state => state.getUserWithGrList,
    getUserWithGrListInactive: state => state.getUserWithGrListInactive,
    userInfo: state => state.userInfo,
    userMinInfo: state => state.userMinInfo,
    addUserPerm: state => state.addUserPerm,
    editUserPerm: state => state.editUserPerm,
    getGroupUserBudget: state => state.getGroupUserBudget,
    getStateName: state => state.getStateName,
    getCountryName: state => state.getCountryName,
    getBusinesstypes: state => state.getBusinesstypes,
    getAuthoriseOfficer: state => state.getAuthoriseOfficer,
    getlatestrecord: state => state.getlatestrecord,
    userCardInfo: state => state.userCardInfo,
    userCompanyId: state => state.userCompanyId,
    myParentCompany: state => state.myParentCompany,
    userAccAccess: state => state.userAccAccess,
    getMyTeamList: state => state.getMyTeamList,
    myTeamList: state => state.myTeamList,
    myAllTeamList: state => state.myAllTeamList,
    addTeamPerm: state => state.addTeamPerm,
    userCompanyStatus: state => state.userCompanyStatus,
    paymentCycle: state => state.paymentCycle,
    userCompanyName: state => state.userCompanyName,
    LockDownStatus: state => state.LockDownStatus,
    adduserRolePerms: state => state.adduserRolePerms,
    getMyTeamListUser: state => state.getMyTeamListUser,
    forgotPasswordMsg: state => state.forgotPasswordMsg,
    getUserPass: state => state.getUserPass,
    updatedUserPass: state => state.updatedUserPass,
    userDetailsUpdate: state => state.userDetailsUpdate,
    setPasswordByAdminReply: state => state.setPasswordByAdminReply,
    getUserInfoToCheck: state => state.getUserInfoToCheck,
    listAllUser: state => state.listAllUser,
    showCreateNewChildCompany: state => state.showCreateNewChildCompany,
    companyDetail: state => state.companyDetail,
    viewSentinelInsightPerm: state => state.viewSentinelInsightPerm,
    allowGenerateStatementPerm: state => state.allowGenerateStatementPerm,
    supportAdminId: state => state.supportAdminId,
    avatar: state => state.avatar,
    companyUsersList: state => state.companyUsersList,
    userInfoFromEmail: state => state.userInfoFromEmail,
    newCompanyToUserConnected: state => state.newCompanyToUserConnected,
    verifyInvitationRes: state => state.verifyInvitationRes,
    newUserEmail: state => state.newUserEmail,
    employeeActivated: state => state.employeeActivated,
    employeeRemoved: state => state.employeeRemoved,
    allUsersRes: state => state.allUsersRes,
    userAssignedCompanies: state => state.userAssignedCompanies,
    companyWiseExpense: state => state.companyWiseExpense,
  },
};
